import supabase from '../supabase/supabase';

export const getWaveAccounts = async (organizationId) => {
  if (!organizationId) {
    throw new Error('Organization ID is required.');
  }

  const {
    data: { session },
    error: sessionError,
  } = await supabase.auth.getSession();

  if (sessionError) {
    throw sessionError;
  }

  if (!session?.access_token) {
    throw new Error(
      'Your session has expired. Please sign in again.'
    );
  }

  const { data, error } = await supabase.functions.invoke(
    'wave-accounts',
    {
      body: {
        organizationId,
      },
    }
  );

  if (error) {
    throw new Error(
      error.message || 'Failed to load Wave accounts.'
    );
  }

  if (!data?.success) {
    throw new Error(
      data?.message || 'Failed to load Wave accounts.'
    );
  }

  return data;
};